import { useCallback } from 'react';

export const useCallbacksSearch = (state, props, onDispatch, subtitleRefs) => {
  const setPositionOfSearch = useCallback(
    (currentPosition, wordsToSearch) => {

      if (!wordsToSearch.length || currentPosition === null) {
        //props.onMove(0, 0);
        return;
      }

      subtitleRefs.current.forEach((subtitleRef) => {
        if (subtitleRef.active) {
          subtitleRef.active = false;
        }
      });

      const wordToSelect = wordsToSearch[currentPosition];

      if (wordToSelect) {
        const activeRef = subtitleRefs.current.find(
          (subtitleRef) => subtitleRef.subtitle.id === wordToSelect.id
        );

        props.onMove(wordToSelect.id, wordToSelect.in);

        if (activeRef) {
          activeRef.setPositionOfSearch(currentPosition, wordsToSearch);
        }
      } else {
        props.onMove(0, 0);
      }
    },
    [props, subtitleRefs]
  );

  const onReplaceAll = useCallback(
    (searchText, replaceText, wholeWord, caseSensitive) => {
      const { wordsToSearch, totalWordsFounded } = state.search;

      if (searchText === '') {
        onDispatch({
          type: 'onShowPopup',
          value: {
            ...state.popup,
            showIcon: true,
            text: {
              fr: 'Vous devez renseigner un mot sur le champ Rechercher pour remplacer.',
              en: 'You must fill in a word in the Search field to replace',
            },
          },
        });

        return;
      }

      if (replaceText === '') {
        onDispatch({
          type: 'onShowPopup',
          value: {
            ...state.popup,
            showIcon: true,
            text: {
              fr: 'Vous devez renseigner une valeur pour remplacer.',
              en: 'You need to fill in a value to replace.',
            },
          },
        });
        return;
      }

      if (totalWordsFounded === 0) {
        onDispatch({
          type: 'onShowPopup',
          value: {
            ...state.popup,
            showIcon: true,
            text: {
              fr: "Vous ne pouvez pas remplacer quand il n'y a pas d'occurrence.",
              en: 'You cannot replace when there is no occurrence.',
            },
          },
        });

        return;
      }

      props.onApplyFilter({
        name: 'replaceAll',
        replace: {
          searchText,
          replaceText,
          wordsToSearch,
        },
      });
    },
    [onDispatch, props, state]
  );

  return {
    
    onReplaceAll,
    setPositionOfSearch
  };
};
